interface Props {
  stages: Array<{
    color: string;
    width: string;
  }>;
}
export const SplittedProgressBar = ({ stages }: Props) => {
  return (
    <div className="flex grow gap-[6px]">
      {stages.map((stage, index) => (
        <div
          key={index}
          className={`h-[6px] rounded-full flex-grow ${stage.color}`}
          style={{ width: stage.width }}
        ></div>
      ))}
    </div>
  );
};
